import React, { useState, useEffect, } from "react";

import InfiniteScroll from "react-infinite-scroller";
import { FaSearch } from "react-icons/fa";
import { LuArrowUpDown } from "react-icons/lu";
import { IoIosArrowUp } from "react-icons/io";
import { IoIosArrowDown } from "react-icons/io";

import "../serviceRequests/serviceRequests.scss";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getTickets } from "../../service/api/ticket/getTickets";



import CustomTable from "../../jsx/components/customTable/customTable";

import searchImg from '../../media/images/servicesAssets/searchImg.png'
import SkeletonForServices from '../../component/skeletonTableRow/skeletonForServices';
import { getProjectsApi } from "../../service/api/ticket/getProjects";
import { setCurrentPage } from "../../feature/userData/userData";
import PrimaryButton from "../../jsx/components/button/primaryButton";

const MyDIYProject = () => {
  const { role, permissionArr } = useSelector((state) => state.user);
  const { myCurrentTab } = useSelector((state) => state.service);

  const permissionArray = permissionArr[0] || [];
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [page, setPage] = React.useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPage, setTotalPage] = useState(1);
  const [sortByValue, setSortByValue] = useState("DESC");
  const [searchValue, setSearchValue] = useState("");
  const [skeltonVal, setSkeltonVal] = useState(false);
  const [columnName, setColumnName] = useState("");
  const [totalNoRecord, setTotalNoRecord] = useState(100);
  const [elements, setElements] = useState([]);

  const [customeSkeletonLoading, setCustomeSkeletonLoading] = useState(false);

  const [flag, setFlag] = useState(false);

  const [filtreBox, setFiltreBox] = useState(false);
  const [filtreValue, SetFiltreValue] = useState(1);


  useEffect(() => {
    dispatch(setCurrentPage("My projects"))
  }, [])



  const getCallHistoryDetails = (res) => {
    const newElements = [...elements, ...res.data];
    const uniqueElements = Array.from(
      new Set(newElements.map(JSON.stringify))
    ).map(JSON.parse);
    setElements(uniqueElements);
    setTotalNoRecord(res.total_count);
    if (res.total_count % pageSize === 0) {
      setTotalPage(parseInt(res.total_count / pageSize));
    } else {
      setTotalPage(parseInt(res.total_count / pageSize + 1));
    }

    if (res.total_count === 0) {
      setTimeout(() => {
        setSkeltonVal(true);
      }, "3000");
    } else {
      setSkeltonVal(true);
    }



  };




  const [isMore, setIsMore] = useState(true);
  const onLoadData = () => {
    setCustomeSkeletonLoading(true);
    let myDiyProject = new FormData();
    myDiyProject.append("user_id_ids", localStorage.getItem("user_id"));
    myDiyProject.append("pagination_flag", 1);
    myDiyProject.append("page_index", page);
    myDiyProject.append("page_size", pageSize);
    myDiyProject.append("sorting_order", sortByValue);
    myDiyProject.append("sorting_column_name", columnName);
    myDiyProject.append("search_area", searchValue);

    setIsMore(false);
    dispatch(
      getProjectsApi(myDiyProject, (res) => {
        if (res.data?.length !== 0) {
          setIsMore(true);
        }
        getCallHistoryDetails(res.data);
        setCustomeSkeletonLoading(false);
      }, () => { setCustomeSkeletonLoading(false); })
    );

    return;
  };



  const onChangePage = (e, p) => {
    // setPage(p)
    handleToggle(null);
    setPage(e);
  };

  const handleSearch = (e) => {
    // setPage(1)
    setPage(1);

    handleToggle(null);
    if (searchValue.trim().length >= 2) {
      const ele = []
      setElements(ele);

      onChangePage(1);
      setColumnName("");
    }
    setSearchValue(e.target.value);
  };






  useEffect(() => {
    onLoadData();
  }, [
    pageSize,
    columnName,
    filtreValue,
    page,
  ]);

  function onLoadDataSearch() {
    let myDiyProject = new FormData();

    myDiyProject.append("user_id_ids", localStorage.getItem("user_id"));
    myDiyProject.append("pagination_flag", 1);
    myDiyProject.append("page_index", page);
    myDiyProject.append("page_size", pageSize);
    myDiyProject.append("sorting_order", sortByValue);
    myDiyProject.append("sorting_column_name", columnName);
    myDiyProject.append("search_area", searchValue);

    setIsMore(false);
    dispatch(
      getProjectsApi(myDiyProject, (res) => {
        if (res.data?.length !== 0) {
          setIsMore(true);
        }
        getCallHistoryDetails(res.data);
        setCustomeSkeletonLoading(false);
      })
    );
  }

  useEffect(() => {
    if (searchValue.trim().length > 2) {

      const ele = [];
      setPage(1);
      setElements(ele);

      setFlag(true);
      const timeOutId = setTimeout(onLoadDataSearch, 1000);
      return () => clearTimeout(timeOutId);
    } else if (searchValue.trim().length === 0 || searchValue.trim() == "") {
      if (flag) {
        onLoadDataSearch();
      }
    }
  }, [searchValue]);



  // With new logic
  const [expandedRow, setExpandedRow] = useState(null);

  const handleToggle = (rowIndex) => {
    if (rowIndex === expandedRow) {
      setExpandedRow(null);
    } else {
      setExpandedRow(rowIndex);
    }
  };

  const isRowExpanded = (rowIndex) => {
    return rowIndex === expandedRow;
  };




  function handleShow(data) {
    localStorage.setItem("projectId", data?.project_id_ids);
    localStorage.setItem("DIYprojectStep", 3);
    navigate('/DIYproject')
  }






  function handleOpenFiltreBox() {
    setFiltreBox(!filtreBox);
  }

  function handleSetFiltreValue(v) {
    SetFiltreValue(v);
    const ele = [];
    setPage(1);
    setElements(ele);

    if (v === 1) {
      setSortByValue("DESC");
    } else if (v === 2) {
      setSortByValue("ASC");
    }
  }





  return (
    <div className="row d-flex justify-content-center align-items-center">
      <div className="col mx-3 align-items-center">


        <div
          className="row shadow-lg px-2 my-1"
          style={{
            backgroundColor: "rgba(251, 252, 255, 1)",
            borderRadius: '16px',
          }}
        >

          <div
            className="row mx-0 my-3 align-items-center "
            style={{ minHeight: "40px" }}>

            <div className="col-12 col-xl-7 d-flex py-1 overflow-auto">
              <div className="row">
                <div className='col-12 px-0 mt-2 pe-2'>
                  <PrimaryButton
                    buttonName={`CREATE A DIY PROJECT`}
                    onClick={() => {
                      navigate("/DIYproject")
                    }}
                    style={{
                      width: '100%',
                      border: 'none',
                      background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                      boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                      fontWeight: '600',
                    }}
                  />
                </div>
              </div>


            </div>


            <div className="col-12 col-xl-5">
              <div className="row">
                <span className="fs-6 p-2 d-flex align-items-center justify-content-end">

                  <span className="fs-5 p-2 d-flex align-items-center">
                    <LuArrowUpDown
                      className="pointer"
                      style={{ marginRight: "4px", color: "black" }}
                      onClick={handleOpenFiltreBox}
                    />
                    <span
                      className="fs-6  pointer"
                      style={{ position: "relative" }}
                      onClick={handleOpenFiltreBox}>
                      {filtreValue == 1 && "Date: Newest first"}
                      {filtreValue == 2 && "Date: Oldest first"}
                      {/* {filtreValue == 3 && " Price: Highest first"}
                      {filtreValue == 4 && "Price: Lowest first"}{" "} */}
                      &nbsp;
                      {filtreBox ? <IoIosArrowUp /> : <IoIosArrowDown />}
                      <span
                        className={`${filtreBox ? "" : "d-none"} p-3`}
                        style={{
                          position: "absolute",
                          top: "26px",
                          width: "170px",
                          zIndex: 1,
                          border: "1px solid lightgray",
                          background: "white",
                          right: "0",
                          boxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.12)",
                        }}>
                        <div className="row">
                          <div
                            className={`${filtreValue == 1 ? "dt" : ""
                              } d-flex justify-content-start m-1 pointer `}
                            onClick={() => {
                              handleSetFiltreValue(1);
                            }}>
                            <div className="d-flex align-items-center" style={{ width: '20px' }}>
                              {filtreValue == 1 && <i className="bi bi-check-lg"></i>}
                            </div>
                            Date: Newest first
                          </div>
                          <div
                            className={`${filtreValue == 2 ? "dt" : ""
                              } d-flex justify-content-start m-1 pointer`}
                            onClick={() => {
                              handleSetFiltreValue(2);
                            }}>
                            <div className="d-flex align-items-center" style={{ width: '20px' }}>
                              {filtreValue == 2 && <i className="bi bi-check-lg"></i>}
                            </div>
                            Date: Oldest first
                          </div>
                          {/* <div
                            className={`${
                              filtreValue == 3 ? "dt" : ""
                            } d-flex justify-content-start m-1 pointer`}
                            onClick={() => {
                              handleSetFiltreValue(3);
                            }}>
                            Price: Highest first
                          </div>
                          <div
                            className={`${
                              filtreValue == 4 ? "dt" : ""
                            } d-flex justify-content-start m-1 pointer`}
                            onClick={() => {
                              handleSetFiltreValue(4);
                            }}>
                            Price: Lowest first
                          </div> */}
                        </div>
                      </span>
                    </span>
                  </span>

                  <span
                    className="fs-6 p-2 d-flex align-items-center"
                    style={{
                      border: "1px solid lightgray",
                      borderRadius: "6px",
                    }}>
                    <FaSearch style={{ marginRight: "4px", color: "black" }} />
                    <input
                      placeholder="Search"
                      style={{ border: "0px", width: "100%" }}
                      onChange={handleSearch}
                      value={searchValue}
                    />
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
        {/* Table Section */}
        <div className="mb-2">



          <CustomTable
            elements={elements}

            tableType={3}
            onRowClick={handleShow}
          />





          {customeSkeletonLoading &&
            <>
              {[...Array(5)].map((data, id) =>
                <SkeletonForServices key={id} />
              )}
            </>
          }

          {customeSkeletonLoading
            ? elements?.length > 0 &&
            totalNoRecord > elements?.length && (
              <div className="text-center pointer my-2">Loading ...</div>
            )
            : elements?.length > 0 &&
            totalNoRecord >
            elements?.length && (
              <div
                className="text-center pointer my-3"
                onClick={() => {
                  setPage(page + 1);
                }}>
                click to view more
              </div>
            )}

          {!customeSkeletonLoading && totalNoRecord == 0 && (
            <div className="mt-5 d-flex justify-content-center align-items-center flex-column">

              <div className="mb-2">
                <img src={searchImg} alt="search" style={{ width: "70px" }} />
              </div>
              <span>
                {`No record found`}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MyDIYProject;
